module.exports = __webpack_public_path__ + "static/decentralised-ee78488aa9522562b05c86f9dd310165.svg";